<component id="app" :is="AppliedLayout" key="root-app" :class="appClasses"></component><app-overlay></app-overlay>